/**
 * Convert a search params object to string. This will be used as a key for storing search results for some of the data state that has
 * search, pagination, and filtering,
 * @param params
 */
export const searchParamsToString = (params) => {
    if (params !== null && params !== undefined) {
        // We can't use JSON.stringify to convert the params to string because it doesn't return the same string given 2 different objects
        // with the same keys/values. e.g.
        //      {a:1, b:2} => '{"a":1,"b":2}'
        //      {b:2, a:1} => '{"b":2,"a":1}'
        // If 2 objects have the same fields and values for those fields, we want to output the same string, the order of the fields does not matter.
        // To guarantee we return the same string given similar objects, we need to sort the keys first
        const sortedKeys = Object.keys(params).sort();
        // now go through the keys and build an Array of key:value separated by commas and convert that array to string.
        return sortedKeys.filter((key) => {
            // filter out null and undefined values
            return params[key] !== undefined && params[key] !== null;
        }).map((key) => {
            return `${key}:${params[key]}`;
        }).join(',') || '_';
    }
    return '_';
};
/**
 * Below are the list of action types that can be dispatched from components. Components don't
 * really need to know about these actions or use them directly. Components should be using the
 * action creators. This will only contain the list of action type that the root reducer can handle.
 * Each sub state will define its own set of action types.
 */
export var BaseActionType;
(function (BaseActionType) {
    BaseActionType["BATCH_ACTIONS"] = "batch actions";
})(BaseActionType || (BaseActionType = {}));
/**
 * Create an action to batch multiple data actions in 1 dispatch
 * @param actions
 */
export const batchActions = (actions) => {
    return {
        type: BaseActionType.BATCH_ACTIONS,
        actions,
    };
};
